import { Phone, Search, MessageSquare, ThumbsUp } from "lucide-react";
import { AnimatedSection, StaggerContainer, StaggerItem } from "@/components/AnimatedSection";

const steps = [
  { icon: Phone, title: "Call or Enquire", desc: "Get in touch by phone, WhatsApp or the quote form. We'll respond quickly." },
  { icon: Search, title: "We Inspect & Explain", desc: "We diagnose the issue and tell you exactly what's needed — in plain English." },
  { icon: MessageSquare, title: "Approve Before We Start", desc: "No work starts without your say-so. Clear quote, no surprises, no pressure." },
  { icon: ThumbsUp, title: "Collect with Confidence", desc: "We call you when it's done. Full report, quality check, ready to drive." },
];

export function WhatToExpect() {
  return (
    <AnimatedSection>
      <section className="py-16 md:py-20">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <div className="text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground">What to Expect</h2>
            <p className="mt-2 text-muted-foreground max-w-lg mx-auto">No surprises. No pressure. Just honest, reliable service from start to finish.</p>
          </div>
          <StaggerContainer className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0 lg:gap-0">
            {steps.map((s, i) => (
              <StaggerItem key={s.title}>
                <div className="relative flex flex-col items-center text-center px-5 py-8">
                  {/* Connector line */}
                  {i < steps.length - 1 && (
                    <div className="hidden lg:block absolute top-12 right-0 w-full h-px bg-border -z-0" style={{ left: '50%' }} />
                  )}
                  <div className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-foreground text-base font-bold shadow-md shadow-primary/15">
                    {i + 1}
                  </div>
                  <s.icon className="mt-4 h-5 w-5 text-primary/70" />
                  <h3 className="mt-3 text-[15px] font-bold text-foreground">{s.title}</h3>
                  <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed max-w-[220px]">{s.desc}</p>
                </div>
              </StaggerItem>
            ))}
          </StaggerContainer>
        </div>
      </section>
    </AnimatedSection>
  );
}
